import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  state: {
    auth: {
      username: 'Courier',
      password: 'Rehmth1324',
    },
    auth_error: false,
    courier: '',
    orders: [],
    order: {},
    order_id: '',
    salary: [],
    menuOpened: false,
    showSuccessOrders: false,
    API: {
      CHECK_AUTH: 'https://1c.tuna-shop.ru/unf02/hs/Delivery/CheckAuth',
      GET_ORDERS: 'https://1c.tuna-shop.ru/unf02/hs/Delivery/GetOrders',
      GET_ORDER:  'https://1c.tuna-shop.ru/unf02/hs/Delivery/GetOrderInfo',
      GET_SALARY: 'https://1c.tuna-shop.ru/unf02/hs/Delivery/GetSettlements',
      ORDER_DONE: 'https://1c.tuna-shop.ru/unf02/hs/Delivery/SetOrderDone'
    }
  },
  mutations: {
    CHECK_AUTH (state, data) {
      state.courier = data.Name
    },
    AUTH_ERROR (state, data) {
      state.auth_error = data
    },
    GET_ORDERS (state, data) {
      state.orders = data
    },
    GET_ORDER (state, data) {
      state.order = data
    },
    SET_ORDER_ID (state, data) {
      state.order_id = data
    },
    GET_SALARY (state, data) {
      state.salary = data
    },
    EXIT_APP (state) {
      localStorage.removeItem('sessionId')
      localStorage.removeItem('pin')
      state.courier = ''
      state.orders = []
      state.order = {}
      state.order_id = ''
      state.salary = []
    },
    SET_MENU_STATE (state, data) {
      state.menuOpened = data
    },
    SHOW_SUCCESS_ORDERS (state, data) {
      state.showSuccessOrders = data
    }
  },
  actions: {
    CHECK_AUTH ({state, commit}, pin) {
      if (state.auth_error) {
        commit('AUTH_ERROR', false)
      }
      return new Promise((resolve, reject) => {
        axios
          .get(state.API.CHECK_AUTH,
            { 
              params: { Code: pin },
              auth: state.auth,
              validateStatus: function (status) {
                return status == 400 || (status >= 200 && status < 300)
              }    
            }
          )
          .then((response) => {
            if (response.status === 200) {
              commit('CHECK_AUTH', response.data)
              localStorage.setItem('pin', pin)
              localStorage.setItem('sessionId', response.data.SessionId)
              resolve(response)
            } else if (response.data.КодОшибки === 1003 || response.data.КодОшибки === 3001 || response.data.КодОшибки === 3000) {       
              if (router.currentRoute.path !== '/') {
                router.push('/')
              } else {
                commit('AUTH_ERROR', true)
                throw new Error(response)
              }
            } else {
              commit('AUTH_ERROR', true)
              throw new Error(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    GET_ORDERS ({commit, state}) {
      return new Promise((resolve, reject) => {
        axios
          .get(state.API.GET_ORDERS,
            {
              params: { SessionId: localStorage.getItem('sessionId') },
              auth: state.auth
            }
          )
          .then(function (response) {
            commit('GET_ORDERS', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    GET_ORDER ({commit, state}, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(state.API.GET_ORDER,
            {
              params: { OrderId: id },
              auth: state.auth
            }
          )
          .then(function (response) {
            commit('GET_ORDER', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    SET_ORDER_ID ({commit}, id) {
      commit('SET_ORDER_ID', id)
    },
    ORDER_DONE ({commit, state}, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(state.API.ORDER_DONE,
            {
              params: { SessionId: localStorage.getItem('sessionId'), OrderId: state.order_id, Time: payload.time, distance: payload.distance, PaymentMethod: payload.payment, PaymentEmailSMS: payload.email },
              auth: state.auth
            }
          )
          .then(function (response) {
            commit('GET_ORDER', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    GET_SALARY ({commit, state}) {
      return new Promise((resolve, reject) => {
        axios
          .get(state.API.GET_SALARY,
            {
              params: { SessionId: localStorage.getItem('sessionId') },
              auth: state.auth
            }
          )
          .then(function (response) {
            commit('GET_SALARY', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    EXIT_APP ({commit}) {    
      commit('EXIT_APP')
    },
    SET_MENU_STATE ({commit}, val) {
      commit('SET_MENU_STATE', val)
    },
    SHOW_SUCCESS_ORDERS ({commit}, val) {
      commit('SHOW_SUCCESS_ORDERS', val)
    }
  }
})
